<script setup lang="ts">
defineProps<{
    label: string;
    value: string;
    semiBold?: boolean;
}>();
</script>

<template>
    <div class="flex flex-col">
        <div class="text-label text-base text-gray-dark mb-1">
            {{ label }}
        </div>
        <div :class="{ 'font-semibold': semiBold }">{{ value }}</div>
    </div>
</template>
